<template>
  <v-popover
    ref="popoverRef"
    interactive
    class="group flex flex-nowrap text-xs"
    tag="div"
    content-tag="div"
    :class="{ 'w-fit justify-end': isMobile }"
    :role="'poper'"
    :trigger="'click'"
    :placement="'left-start'"
    :append-to="bodyRef"
    :on-trigger="onTrigger"
    :on-untrigger="onTrigger"
    :on-show="onShowPopup"
  >
    <CardTag
      v-for="tag in tags.slice(0, tagsLimit)"
      :key="tag.id"
      :name="tag.name"
      :tooltip="false"
      :color="tag.color"
      :card-hover="cardHover"
    />
    <div class="flex items-center">
      <span
        v-if="tags.length > tagsLimit"
        class="px-1 text-text-default"
      >
        +{{ tags.length - tagsLimit }}
      </span>
      <span
        v-if="!tags.length && !readOnly"
        class="flex invisible items-center text-text-default"
      >
        <em
          :style="getCustomIconStyle(iconPath('plus'))"
          class="custom-icons w-3 h-3 mr-1 bg-icon-default"
        >
          add
        </em>
        {{ translate('tags') }}
      </span>
    </div>
    <template #content="{ state, hide }">
      <CardTagsPopupWrapper
        v-if="state.isVisible"
        ref="tagsPopupWrapperRef"
        :card-id="cardId"
        @close-tippy="hide"
        @closePopup="hide"
        @esc="hide"
      />
    </template>
  </v-popover>
</template>

<script>
import boardListCardMixin from '@/mixins/boardListCardMixin';
import customIconsMixin from '@/mixins/customIconsMixin';
import CardTag from '@/components/elements/CardTag';
import { computed } from 'vue';
import useBoardEmbed from '@/boards/composables/useBoardEmbed';
import CardTagsPopupWrapper from '@/components/widgets/CardTagsPopupWrapper.vue';
import useCurrentRole from '@/utilities/composables/useCurrentRole';

export default {
  name: 'CardTags',
  components: {
    CardTag,
    CardTagsPopupWrapper,
  },
  mixins: [boardListCardMixin, customIconsMixin],
  provide() {
    return {
      currentCardId: this.cardId,
    };
  },
  props: {
    cardId: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    cardHover: {
      type: Boolean,
      default: false,
    },
    listId: {
      type: [String, Number],
      required: false,
      default: '',
    },
  },

  setup() {
    const { embeddedBoardAttributes, embed } = useBoardEmbed();
    const { isGuestReader } = useCurrentRole();
    const readOnly = computed(() => embeddedBoardAttributes.value?.readOnly || isGuestReader.value);

    return {
      embeddedBoardAttributes,
      readOnly,
      embed,
      bodyRef: document.body,
    };
  },

  data() {
    return {
      tagsPopupShown: false,
    };
  },
  computed: {
    tagsLimit() {
      if (this.isCardsLayoutTimeline) return 2;
      if (this.isCardsLayoutList) return 5;
      return this.isMobile ? 3 : 6;
    },
    isCardsLayoutTimeline() {
      return this.cardsLayout === 'timeline';
    },
    isCardsLayoutList() {
      return this.cardsLayout === 'list';
    },
    tags() {
      return this.card.tags
        ? [...this.card.tags].sort((a, b) => a.name.localeCompare(b.name))
        : this.card.tags || [];
    },

    card() {
      return this.$store.getters.getCards[this.cardId] || {};
    },

    visible() {
      return true;
    },

    isView() {
      return (
        this.$route.name === this.$constants.routeNames.view ||
        this.$route.name === this.$constants.routeNames.newView ||
        this.$route.name === this.$constants.routeNames.views
      );
    },

    cardsLayout() {
      return this.embed ? this.embeddedBoardAttributes.layout : this.$store.getters.cardsLayout();
    },
  },
  methods: {
    onShowPopup() {
      return !(this.isMobile || this.readOnly);
    },
    onTogglePopup() {
      this.hideEditMode();
      this.hideCardActionsDropdown();
      this.hideMemberDropdown();
    },
    showPopup() {
      this.$refs.popoverRef?.show();
    },
    onTrigger(i, event) {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      this.onTogglePopup();
    },
  },
};
</script>
